import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import VerBulkWhatsappCampaignsDatatable from './ver-bulk-whatsapp-campaigns-datatable';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Ver_bulk_whatsapp_campaigns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            results: [],
            filter: '',
            temp: [],
        };
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentWillMount() {
        this.loadCampaigns();
    }

    loadCampaigns() {
        const user = AuthService.getCurrentUser();
        ApiService.getBulkWhatsappCampaigns(user.token).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({ results: res.data, temp: res.data });
                }
            },
            (error) => {
                const msg =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(msg);
            }
        );
    }

    onDelete(id) {
        const user = AuthService.getCurrentUser();
        ApiService.deleteBulkWhatsappCampaign(user.token, id).then(
            () => {
                toast.success('Campaña eliminada');
                this.loadCampaigns();
            },
            (error) => {
                const msg =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(msg);
            }
        );
    }

    onChangeFilter(e) {
        const val = e.target.value.toLowerCase();
        this.setState({ filter: val });
        if (this.state.temp.length > 0) {
            const columns = Object.keys(this.state.temp[0]);
            const rows = this.state.temp.filter((d) =>
                columns.some((col) => d[col] && d[col].toString().toLowerCase().includes(val))
            );
            this.setState({ results: rows });
        }
    }

    render() {
        const { results } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Campañas WhatsApp Masivas" parent="Promociones" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Gestión de Campañas WhatsApp Masivas</h5>
                        </div>
                        <div className="card-body">
                            <div className="btn-popup pull-right">
                                <Link
                                    to={`${process.env.PUBLIC_URL}/create-bulk-whatsapp-campaign`}
                                    className="btn btn-secondary"
                                >
                                    Nueva Campaña
                                </Link>
                            </div>
                            <div className="clearfix"></div>
                            <div className="col-md-6 table-filter" style={{ marginBottom: '15px' }}>
                                <input
                                    placeholder="Filtrar campañas..."
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    onInput={this.onChangeFilter}
                                />
                            </div>
                            {results.length === 0 ? (
                                <p className="text-muted">No hay campañas creadas.</p>
                            ) : (
                                <VerBulkWhatsappCampaignsDatatable
                                    myData={results}
                                    pageSize={results.length <= 10 ? results.length : 10}
                                    pagination={true}
                                    onDelete={this.onDelete}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        );
    }
}

export default Ver_bulk_whatsapp_campaigns;
